import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useStore } from '../../hooks/useStore';
import { ContentHead } from '../../lib/components';
import { DataGrid, DataGridElement } from '../../lib/components/compound/dataGrid';
import { ContentBox } from '../../lib/components/compound/pages/contentBox';
import Util from '../../misc/util';
import { TaskErrorElement } from './shared/error';

export const TaskDetailsPage: FC = observer(() => {
  const { t } = useTranslation();
  const { importId } = useParams();
  const { impexStore, companyStore } = useStore();

  const type = importId ? 'import' : 'export';

  useEffect(() => {
    if (!companyStore.company) return;
    const abortController = new AbortController();
    const fetch = async () => {
      try {
        if (!impexStore.ImportList.length) {
          await impexStore.fetchImportList();
        }
        if (importId && impexStore.currentImport?.id != importId) {
          impexStore.currentImportId = importId;
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
        }
      }
    };
    fetch();
    return () => abortController.abort();
  }, [companyStore.company]);

  return (
    <ContentBox
      headComponent={
        <ContentHead headline={`${t('tasks:TITLE', { context: type })}`} showActions={false} />
      }
    >
      <DataGrid>
        <DataGridElement title={t('tasks:ID')} value={impexStore.currentImport?.id} />
        <DataGridElement
          title={t('tasks:CREATE_DATE')}
          value={Util.formatDate(impexStore.currentImport?.created_at)}
        />
        <DataGridElement title={t('tasks:CREATOR')} value={impexStore.currentImport?.user} />
        <DataGridElement
          title={t('tasks:TYPE_TITLE')}
          value={impexStore.currentImport?.import_type}
        />
        <DataGridElement title={t('tasks:STATUS')} value={impexStore.currentImport?.status} />
        <DataGridElement title={t('tasks:FILE')} value={impexStore.currentImport?.file.name} />
      </DataGrid>
      {impexStore.currentImport?.errors &&
        impexStore.currentImport?.errors.length > 0 &&
        impexStore.currentImport?.errors.map(
          (
            error: { error_msg: string; row_number: number; row_content: string },
            index: number
          ) => (
            <TaskErrorElement
              key={index}
              title={t('tasks:IMPORT_ERROR_TITLE', { row: error.row_number + 1 })}
              details={{
                msg: error.error_msg,
                content: error.row_content,
                row: error.row_number + 1
              }}
            />
          )
        )}
    </ContentBox>
  );
});
